<template>
  <div class="lending-calculator">
    <label class="auto-lending__header-label">
      Стоимость автомобиля:
      <input
        v-model.number="carPrice"
        class="js-landing-calculator-car-cost"
        type="number"
        min="0"
      >
    </label>
    <label class="auto-lending__header-label">
      Первоначальный платёж, руб:
      <input
        v-model.number="initialPayment"
        class="js-landing-calculator-first-payment"
        type="number"
        min="0"
      >
    </label>
    <label class="auto-lending__header-label">
      Желаемый срок кредита (лет):
      <input
        v-model.number="term"
        class="small js-landing-calculator-term"
        type="number"
        min="0"
      >
    </label>
    <p><b>Ежемесячный платеж по кредиту, руб.</b></p>
    <p v-if="!price">
      Чтобы увидеть сумму платежа в месяц заполните стоимость автомобиля и срок кредита
    </p>
    <div v-else>
      <div class="auto-lending__header-label">
        <span>От: {{ price[0] }} руб.</span>
        <span>До: {{ price[1] }} руб.</span>
      </div>
    </div>

    <div :style="{display: price ? 'block' : 'none'}">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LendingCalculator',
  data() {
    return {
      carPrice: 0,
      initialPayment: 0,
      term: 0,
    }
  },
  computed: {
    price() {
      if (this.carPrice === 0 || this.term === 0) {
        return 0
      }

      const monthly = (this.carPrice - this.initialPayment) / this.term / 12

      return [
        (monthly * 1.45).toFixed(2),
        (monthly * 2).toFixed(2),
      ]
    },
  }
}
</script>

<style lang="scss">
.lending-calculator {
  //
}
</style>
